import { CATEGORIES_WITHOUT_OCCUPANCY, CATEGORY_OPTIONS, FORM_TYPE_OPTIONS, STATUS_HOSPITALITY, STATUS_VACANT_PRE_RENTED, STATUS_VACANT_RENTED } from "./constants"
import type { FormTypeOption } from "./types"

export function categoryHasOccupancyStatus(category: string): boolean {
  return !CATEGORIES_WITHOUT_OCCUPANCY.includes(category)
}

export function getStatusOptionsForCategory(category: string): { value: string; label: string }[] {
  if (!category || CATEGORIES_WITHOUT_OCCUPANCY.includes(category)) return []
  if (category === "Flat or Apartment") return STATUS_VACANT_RENTED
  if (category === "Hospitality") return STATUS_HOSPITALITY
  return STATUS_VACANT_PRE_RENTED
}

export function getFormTypeKeyFromCategoryAndStatus(category: string, status: string): string {
  if (!category) return ""
  if (category === "Franchise") return "Franchise"
  if (category === "Land") return "Land"
  if (category === "Admin Form") return "Admin Form"
  if (!status) return ""
  if (category === "Builder Floor") return status === "Vacant" ? "Builder Floor (Vacant)" : "Builder Floor (Pre-Rented)"
  if (category === "Flat or Apartment") return status === "Vacant" ? "Flat or Apartment (Vacant)" : "Flat or Apartment (Rented)"
  if (category === "Commercial Office Space") return status === "Vacant" ? "Commercial Office Space (Vacant)" : "Commercial Office Space (Pre-Rented)"
  if (category === "Independent Building (Commercial office)") return status === "Vacant" ? "Independent Building (Commercial office - Vacant)" : "Independent Building (Commercial office - Pre-Rented)"
  if (category === "Independent Building (Industrial)") return status === "Vacant" ? "Independent Building (Industrial - Vacant)" : "Independent Building (Industrial - Pre-Rented)"
  if (category === "Independent Building (Retail)") return status === "Vacant" ? "Independent Building (Retail - Vacant)" : "Independent Building (Retail - Pre-Rented)"
  if (category === "Retail Space") return status === "Vacant" ? "Retail Space (Vacant)" : "Retail Space (Pre-Rented)"
  if (category === "Warehouse") return status === "Vacant" ? "Warehouse (Vacant)" : "Warehouse (Pre-Rented)"
  if (category === "Hospitality") return status === "Operational" ? "Hospitality (Operational)" : "Hospitality (Vacant or Non-Operational)"
  return ""
}

export function getCategoryOptionsForUser(_role?: string | null): { value: string; label: string }[] {
  return CATEGORY_OPTIONS.filter((o) => o.value !== "Admin Form")
}

export function getFormTypeOptionsForUser(_role?: string | null): FormTypeOption[] {
  return FORM_TYPE_OPTIONS.filter((o) => o.value !== "Admin Form")
}
